import { render, staticRenderFns } from "./ReportarSugerencia.vue?vue&type=template&id=f2cd1d7a&"
import script from "./ReportarSugerencia.vue?vue&type=script&lang=js&"
export * from "./ReportarSugerencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QPageSticky,QForm,QCard,QCardSection,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QPage,QPageSticky,QForm,QCard,QCardSection,QInput,QBtn}, component.options.components || {})
